import { OVERSTAY_HOURS, isOverstay } from "./ParkingGrid";

const Swatch = ({ className }) => <i className={`w-3 h-3 inline-block ${className}`} />;

export const GridLegend = ({ spaces, now }) => (
  <div className="flex flex-wrap gap-6 label-tech">
    <span className="flex items-center gap-2"><Swatch className="border border-[#262626]" />Available</span>
    <span className="flex items-center gap-2"><Swatch className="bg-[#FF3B30]" />Occupied</span>
    <span className="flex items-center gap-2"><Swatch className="bg-[#FFD60A]" />Reserved</span>
    <span className="flex items-center gap-2" data-testid="overstay-legend">
      <Swatch className="bg-[#FF9F0A]" />
      Overstay &gt; {OVERSTAY_HOURS}h ({spaces.filter((s) => isOverstay(s, now)).length})
    </span>
  </div>
);
